import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';

/** The board's day: this device's midnight to midnight. */
export const todayRange = (now: Date) => ({
  start: startOfDay(now),
  end: endOfDay(now),
});
